import { Restriction, RestrictionConditions } from '@mews-commander/data-access';
import { DateConditions, Dependencies, RowConditions } from '../types';

export const isDateWithinRestrictionDateRange = (
    { startUtc, endUtc, days }: RestrictionConditions,
    { utcDate, day }: DateConditions
) => {
    const isDayRestricted = days.includes(day);

    if (!startUtc && !endUtc) {
        return isDayRestricted;
    }
    if (!startUtc && endUtc) {
        return utcDate <= endUtc && isDayRestricted;
    }
    if (!endUtc && startUtc) {
        return utcDate >= startUtc && isDayRestricted;
    }
    if (startUtc && endUtc) {
        return utcDate >= startUtc && utcDate <= endUtc && isDayRestricted;
    }
    return true;
};

const matchesResourceCategoryConditions = (
    restriction: Restriction,
    rowConditions: RowConditions,
    dependencies: Dependencies
) => {
    if (restriction.conditions.resourceCategoryType === null && restriction.conditions.resourceCategoryId === null) {
        return true;
    }
    if (
        rowConditions.resourceCategoryType === restriction.conditions.resourceCategoryType &&
        rowConditions.resourceCategoryId === restriction.conditions.resourceCategoryId
    ) {
        return true;
    }
    if (
        rowConditions.resourceCategoryId &&
        dependencies.resourceCategories[rowConditions.resourceCategoryId].type ===
            restriction.conditions.resourceCategoryType
    ) {
        return true;
    }
    return false;
};

const matchesDateAndRowConditions =
    (rowConditions: RowConditions, dateConditions: DateConditions, dependencies: Dependencies) =>
    (restriction: Restriction) => {
        if (restriction.conditions.type !== rowConditions.type) {
            return false;
        }
        if (!isDateWithinRestrictionDateRange(restriction.conditions, dateConditions)) {
            return false;
        }
        if (
            restriction.conditions.rateGroupId === null &&
            restriction.conditions.baseRateId === null &&
            restriction.conditions.exactRateId === null
        ) {
            return matchesResourceCategoryConditions(restriction, rowConditions, dependencies);
        }
        if (
            rowConditions.rateGroupId === restriction.conditions.rateGroupId &&
            rowConditions.rateId === (restriction.conditions.exactRateId || restriction.conditions.baseRateId)
        ) {
            return matchesResourceCategoryConditions(restriction, rowConditions, dependencies);
        }
        if (
            rowConditions.rateId &&
            dependencies.rates[rowConditions.rateId].rateGroupId === restriction.conditions.rateGroupId
        ) {
            return matchesResourceCategoryConditions(restriction, rowConditions, dependencies);
        }
        if (
            rowConditions.rateId &&
            dependencies.rates[rowConditions.rateId].baseRateId !== null &&
            dependencies.rates[rowConditions.rateId].baseRateId === restriction.conditions.baseRateId
        ) {
            return matchesResourceCategoryConditions(restriction, rowConditions, dependencies);
        }
        return false;
    };

export default matchesDateAndRowConditions;
